import Vue from 'vue';
import { ValidationProvider } from 'vee-validate';

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
